import {
  isTripMasterSurface,
  shouldStripTripMasterAgencySession,
  stripHotelsRiverAgencySession,
} from "./tripMasterEnv";

/**
 * Runs before App/AppContext so a leftover HotelsRiver session on this origin
 * cannot hydrate an agent user and bounce `/` to `/login`.
 * Ops (`/ops`) keeps the HotelsRiver agency session for operations login.
 */
if (typeof window !== "undefined" && isTripMasterSurface()) {
  if (shouldStripTripMasterAgencySession(window.location.pathname)) {
    stripHotelsRiverAgencySession();
  }
  try {
    const sw = window.navigator?.serviceWorker;
    if (sw?.getRegistrations) {
      sw.getRegistrations()
        .then((regs) => {
          regs.forEach((reg) => {
            try {
              reg.unregister();
            } catch {
              /* ignore */
            }
          });
        })
        .catch(() => {});
    }
  } catch {
    /* ignore */
  }
}
